/* eslint-disable import/prefer-default-export */
const getCanonicalUrl = () => {
  const $link = document.querySelector("link[rel='canonical']");
  return $link?.href || "";
};

/* eslint-disable prefer-regex-literals */
export const isProduction = () =>
  window.jiffy?.env === "production" || new RegExp("https://www.jiffy.com").test(getCanonicalUrl());
